import styles from "./Dots.module.css";

function createDotsArr(value, maxValue) {
	let dotsArr = [
		...Array(Math.floor(value)).fill(true),
		...Array(Number((maxValue - value).toFixed(0))).fill(false),
	];

	return dotsArr;
}

const dotColor = {
	active: ["#ff3333", "#cc0000", "#990000"],
	inactive: "#D9D9D9",
};

function Dots({ type, value, maxValue }) {
	const dots = createDotsArr(value, maxValue);
	return (
		<div className={styles.container}>
			<div className={styles.dotsContainer}>
				{dots.map((active, i) => {
					return (
						<svg
                            key={`${type}-${i}`}
							width="16"
							height="17"
							viewBox="0 0 16 17"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								cx="8"
								cy="8.31909"
								r="8"
								fill={
									active
										? dotColor["active"][i]
										: dotColor["inactive"]
								}
							/>
						</svg>
					);
				})}
			</div>
		</div>
	);
}

export default Dots;
